import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    ProductCategoryUpdate as ProductCategoryUpdateMutation,
    ProductCategoryUpdateVariables as ProductCategoryUpdateMutationVariables,
    ProductCategoryUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_PRODUCT_CATEGORY from '../mutations/update-product-category.graphql';

export function useUpdateProductCategory(): {
    updateProductCategory: (arg1: ProductCategoryUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [updateProductCategory, {loading, error}] = useMutation<
        ProductCategoryUpdateMutation,
        ProductCategoryUpdateMutationVariables
    >(UPDATE_PRODUCT_CATEGORY);

    return {
        updateProductCategory: (input: ProductCategoryUpdateInput) => {
            return updateProductCategory({
                variables: {input},
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
